<template>
  <CDialog v-model="isOpen" class="dialog--small">
    <header class="dialog-header">
      <h1 class="h4 mrgv0">
        {{ $t('call-deviation.dialog.title') }}
      </h1>
    </header>

    <div class="dialog-body">
      <CallableUsers
        v-model="callableUser"
        :placeholder="$t('call-deviation.dialog.search.placeholder')"
        label="label"
        autofocus
      />
    </div>

    <div class="dialog-footer">
      <ListInline align="center" size="small">
        <li>
          <Btn variant="outline" @click="isOpen = false">
            {{ $t('call-deviation.dialog.cancel') }}
          </Btn>
        </li>
        <li>
          <Btn variant="primary" :disabled="!callableUser" @click="submit">
            {{ $t('call-deviation.enable') }}
          </Btn>
        </li>
      </ListInline>
    </div>
  </CDialog>
</template>

<script>
import { mapGetters } from 'vuex';

import eventBus from '@/eventBus';

import CallableUsers from '@/components/callable-users/CallableUsers';

export default {
  components: {
    CallableUsers,
  },

  data() {
    return {
      isOpen: false,
      callableUser: null,
    };
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),

    availableCallableUsers() {
      const users = Object.values(this.$store.state.users.index);

      return users.map(user => ({
        value: user,
        label:
          user.first_name && user.last_name
            ? `${user.first_name} ${user.last_name}`
            : user.username,
      }));
    },
  },

  mounted() {
    eventBus.$on('toggleDeviationDialog', this.handleToggle);
  },

  beforeDestroy() {
    eventBus.$off('toggleDeviationDialog', this.handleToggle);
  },

  methods: {
    handleToggle() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.callableUser = null;
      }
    },

    submit() {
      this.$emit('update', this.callableUser.username);
      this.callableUser = null;
    },
  },
};
</script>
